import React, { Dispatch, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";


import { useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import remove from 'lodash/remove';
import { Toast, Button, Input, TextArea, Select, SelectOption, Slider } from "@kaleyra/emmy";
import ReactQuill from 'react-quill';
import Styles from './index.module.scss';
import errorIcon from '../../../../assets/error.svg';
import { networkCall, apiBaseUrl } from '../../../../utils/networkCall';
import { fetchIdentifiersList, clearVerifyStatusState } from '../../../../store/actions/verify.action';
import { IStateType } from '../../../../store/models/root.interface';
import { Identifier } from '../../../../store/models/identifier.interface';
import { DOMAIN_EU } from '../../../../base';
import { validateEmail } from "../../../../utils";
import 'react-quill/dist/quill.snow.css';
import { saveTemplate } from "../../../../store/actions/failover.action";


export type MapStateType = {
    params: any;
}

export type DispatchPropsType = {
    onClose: () => void;
    fetchFailoverTemplates: () => void
}

interface EmailChannelState {
    email: string;
    subject: string;
}

interface CommonChannleState {
    name: string;
    OTP: string;
}

interface selectTypes {
    key: string;
    value: string;
}

interface SmsChannelState {
    senderId: string;
    // entityId: string;
    templateId: string;
}

interface VoiceChannelState {
    language: string;
    speechRate: string;
}

const CreateFailoverTemplates: React.FC<MapStateType & DispatchPropsType> = ({ onClose, fetchFailoverTemplates, params }) => {

    const { t } = useTranslation();

    let POD = "SG";
    const { hostname } = window.location;
    if (hostname === DOMAIN_EU) {
        POD = "EU";
    }

    const dispatch: Dispatch<any> = useDispatch();

    const editData = params.extraParam;

    const [speedRates, setSpeedRates] = useState([] as unknown as selectTypes[]);
    const [languages, setLanguages] = useState([] as unknown as selectTypes[]);
    const [channelSelected, setChannelSelected] = useState(undefined as unknown as string);
    const [commonState, setCommonState] = useState({} as CommonChannleState);
    const [emailStates, setEmailStates] = useState({} as EmailChannelState);
    const [smsStates, setSmsStates] = useState({} as SmsChannelState);
    const [voiceStates, setVoiceStates] = useState({ language: "en-US", speechRate: "medium" } as VoiceChannelState);

    const senderList = useSelector((state: IStateType) => state.identifiers);
    const { data, error, message } = senderList;
    const templatesReducer = useSelector((state: IStateType) => state.verifyTemplates);
    const { saveLoading } = templatesReducer;
    const profileDetails = useSelector((state: IStateType) => state.profile);
    const { country_id, user_id } = profileDetails.fullProfile;

    useEffect(() => {
        dispatch(fetchIdentifiersList(1000, 0));
        networkCall('get', `/tts-config`, apiBaseUrl.baseUrl).then((res: any) => {
            if (res.error && isEmpty(res.error)) {
                if (res?.data?.speed) {
                    const speed = [];
                    for (let key in res.data.speed) {
                        speed.push({
                            key: key,
                            value: res.data.speed[key]
                        })
                    }
                    setSpeedRates(speed);
                }
                if (res?.data?.speed) {
                    const lang = [];
                    for (let key in res.data.languages) {
                        lang.push({
                            key: key,
                            value: res.data.languages[key]
                        })
                    }
                    setLanguages(lang);
                }
            } else {
                Toast(res.message, "error");
            }
        });
    }, []);

    useEffect(() => {
        if (!isEmpty(editData)) {
            setChannelSelected(editData.channel_name);
            setCommonState({ ...commonState, name: editData.name, OTP: editData.body });
            if (editData.channel_name.toLowerCase() === "voice") {
                setVoiceStates({ ...voiceStates, language: JSON.parse(editData.meta_value)?.language, speechRate: JSON.parse(editData.meta_value)?.speech_rate })
            } else if (editData.channel_name.toLowerCase() === "email") {
                setEmailStates({ ...emailStates, subject: JSON.parse(editData.meta_value)?.subject })
            }
        }
    }, [editData])

    useEffect(() => {
        if (error && message.length) {
            Toast(message, "error", () => {
                dispatch(clearVerifyStatusState());
            });
        }
    }, [error, message]);

    const allChannels = [
        // {
        //     key: "sms",
        //     value: t("mainSMS")
        // },
        {
            key: "voice",
            value: t("mainVoice")
        },
        {
            key: "email",
            value: t("mainEmail")
        }
    ];

    const validateCheck = (field: string) => {
        if (field === "otp") {
            if (commonState?.OTP?.length) {
                if (commonState.OTP.toLocaleLowerCase().includes("{otp}")) {
                    return false;
                } else {
                    return true;
                }
            }
        } else if (field === "email") {
            if (emailStates?.email?.length) {
                if (!validateEmail(emailStates.email)) {
                    return true;
                }
            }
        } else if (field === "templateName") {
            if (commonState?.name?.length) {
                if (commonState.name.trim().length < 3 || commonState.name.trim().length > 40) {
                    return true;
                }
            }
        }
        // else if(field === "entityId"){
        //     if(smsStates?.entityId?.length){
        //         if(isNaN(Number(smsStates.entityId))){
        //             return true;
        //         }
        //         if(smsStates?.entityId?.length < 12 || smsStates?.entityId?.length > 19){
        //             return true;
        //         }
        //     }
        // }
        else if (field === "templateId") {
            if (smsStates?.templateId?.length) {
                if (isNaN(Number(smsStates.templateId))) {
                    return true;
                }
                if (smsStates?.templateId?.length < 12 || smsStates?.templateId?.length > 30) {
                    return true;
                }
            }
        }
        return false;
    }

    const renderSmsForm = () => {
        remove(data, { identifier: "KLRHXA" });
        return (
            <>
                <Select
                    label={t("verifySenderID")}
                    placeholder={t("verifySenderID")}
                    selectClassName={Styles.selectBox}
                    className={Styles.selectBoxWraper}
                    value={smsStates.senderId}
                    onChange={(key: any) => setSmsStates({ ...smsStates, senderId: key })}
                >
                    {data.map((option: Identifier) => {
                        return <SelectOption key={option.id} value={option.identifier}>{option.identifier}</SelectOption>
                    })}
                </Select>
                {
                    POD === "SG" && country_id === 277 &&
                    <>
                        {/* <Input 
                            placeholder={t("verifyEntityId")}
                            label={t("verifyEntityId")}
                            value={smsStates.entityId}
                            bottomLabelType={validateCheck("entityId")?"error":undefined}
                            bottomLabel={<><img src={errorIcon} alt={"error"} className={Styles.errorIcon}/>{t("verifyOnlyNumbers12to19")}</>}
                            onChange={handleEntityIdChange}
                        /> */}
                        <Input
                            placeholder={t("verifyTemplateId")}
                            label={t("verifyTemplateId")}
                            value={smsStates.templateId}
                            bottomLabelType={validateCheck("templateId") ? "error" : undefined}
                            bottomLabel={<><img src={errorIcon} alt={"error"} className={Styles.errorIcon} />{t("verifyOnlyNumbers12to19")}</>}
                            onChange={handleTemplateIdChange}
                        />
                    </>
                }
            </>
        )
    }

    const renderEmailForm = () => {
        return (
            <>
                {/* <Input
                    placeholder={t("verifyFromEmail")}
                    label={t("verifyFromEmail")}
                    value={emailStates.email}
                    onChange={(e) => setEmailStates({ ...emailStates, email: e.target.value.trim() })}
                    bottomLabelType={validateCheck("email") ? "error" : undefined}
                    bottomLabel={<><img src={errorIcon} alt={"error"} className={Styles.errorIcon} />{t("verifyValidEmail")}</>}
                /> */}
                <Input
                    placeholder={t("verifyEmailSubject")}
                    label={t("verifyEmailSubject")}
                    value={emailStates.subject}
                    onChange={(e) => setEmailStates({ ...emailStates, subject: e.target.value })}
                />
            </>
        )
    }

    const renderVoiceForm = () => {
        return (
            <>
                <Select
                    label={t("mainLanguage")}
                    placeholder={t("mainLanguage")}
                    selectClassName={Styles.selectBox}
                    className={Styles.selectBoxWraper}
                    value={voiceStates.language}
                    onChange={(key: any) => setVoiceStates({ ...voiceStates, language: key })}
                >
                    {languages.map((option) => {
                        return <SelectOption key={option.key} value={option.key}>{option.value}</SelectOption>
                    })}
                </Select>
                <Select
                    label={t("mainSpeechRate")}
                    placeholder={t("mainSpeechRate")}
                    selectClassName={Styles.selectBox}
                    className={Styles.selectBoxWraper}
                    value={voiceStates.speechRate}
                    onChange={(key: any) => setVoiceStates({ ...voiceStates, speechRate: key })}
                >
                    {speedRates.map((option) => {
                        return <SelectOption key={option.key} value={option.key}>{option.value}</SelectOption>
                    })}
                </Select>
            </>
        )
    }

    const handleTemplateNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.trim().length === 0) {
            setCommonState({ ...commonState, name: "" });
        } else {
            setCommonState({ ...commonState, name: e.target.value });
        }
    }

    const handleTemplateIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.trim().length === 0) {
            setSmsStates({ ...smsStates, templateId: "" });
        } else {
            setSmsStates({ ...smsStates, templateId: e.target.value });
        }
    }

    const checkSaveButtonEnabled = () => {
        const { name, OTP } = commonState;
        if (name?.trim().length >= 3 && name?.trim().length <= 40 && OTP?.length) {
            if (channelSelected === "sms") {
                const { senderId, templateId } = smsStates;
                if (senderId?.length) {
                    if (POD === "SG" && country_id === 277) {
                        // if(isNaN(Number(entityId))){
                        //     return true;
                        // }
                        // if(entityId?.length < 12){
                        //     return true;
                        // }
                        if (isNaN(Number(templateId))) {
                            return true;
                        }
                        if (templateId?.length < 12 || templateId?.length > 30) {
                            return true;
                        }
                    }
                    return false;
                }
            } else if (channelSelected === "voice") {
                const { language, speechRate } = voiceStates;
                if (language?.length && speechRate?.length) {
                    return false;
                }
            } else if (channelSelected === "email") {
                const { email, subject } = emailStates;
                if (subject?.trim().length) {
                    return false;
                }
            }
        }
        return true;
    }

    const handleSaveClick = () => {

        const data: any = {
            templateName: commonState.name,
            templateContent: commonState.OTP
        }

        if (channelSelected === "voice") {
            data.language = voiceStates.language;
            data.speechRate = voiceStates.speechRate;
            data.userId = user_id;
        } else if (channelSelected === "email") {
            // data.email = emailStates.email;
            data.subject = emailStates.subject;
            data.userId = user_id;
        }
        if (isEmpty(editData)) {
            dispatch(saveTemplate("post", channelSelected, data, (flag: boolean, message: string) => {
                saveCallback(flag, message);
            }));
        } else {
            data['id'] = editData.id
            dispatch(saveTemplate("put", channelSelected, data, (flag: boolean, message: string) => {
                saveCallback(flag, message);
            }));
        }
    }

    const saveCallback = (flag: boolean, message: string) => {
        if (flag) {
            Toast(message, "success");
            onClose();
            fetchFailoverTemplates();
        } else {
            Toast(message, "error");
        }
    }

    const renderSliderBody = () => {
        return (
            <div className={Styles.fromWrapper}>
                <Select
                    label={t("mainSelectChannel")}
                    placeholder={t("mainSelectChannel")}
                    selectClassName={Styles.selectBox}
                    className={Styles.selectBoxWraper}
                    value={channelSelected}
                    onChange={(key: any) => {
                        setChannelSelected(key)
                    }
                    }
                >
                    {allChannels.map((option) => {
                        return <SelectOption key={option.key} value={option.key}>{option.value}</SelectOption>
                    })}
                </Select>
                {/* {channelSelected === "sms" && renderSmsForm()} */}
                {channelSelected === "voice" && renderVoiceForm()}
                {channelSelected === "email" && renderEmailForm()}
                {
                    channelSelected !== undefined &&
                    <>
                        <Input
                            placeholder={t("verifyTemplateName")}
                            label={t("verifyTemplateName")}
                            value={commonState.name}
                            onChange={handleTemplateNameChange}
                            bottomLabelType={validateCheck("templateName") ? "error" : undefined}
                            bottomLabel={<><img src={errorIcon} alt={"error"} className={Styles.errorIcon} />{t("verifyTemplateNameMinMax")}</>}
                        />
                        {channelSelected !== "email" ? <TextArea
                            placeholder={t("KLR03073")}
                            label={t("KLR03073")}
                            value={commonState.OTP}
                            onChange={(e) => setCommonState({ ...commonState, OTP: e.target.value })}
                        /> :
                            <><ReactQuill
                                placeholder={t("KLR03073")}
                                value={commonState.OTP || ""}
                                onChange={(text: string) => setCommonState({ ...commonState, OTP: text })}
                                className={Styles.RQCustomWrapper}
                                modules={{
                                    toolbar: [
                                        ['bold', 'italic', 'underline', 'strike'],
                                        [{ 'list': 'ordered' }, { 'list': 'bullet' },
                                        { 'indent': '-1' }, { 'indent': '+1' }],
                                    ],
                                    clipboard: {
                                        matchVisual: false,
                                    }
                                }}
                                formats={[
                                    'header', 'font', 'size',
                                    'bold', 'italic', 'underline', 'strike', 'blockquote',
                                    'list', 'bullet', 'indent',
                                    // 'link', 'image', 'video'
                                ]}
                                bounds={'.app'}
                                theme={'snow'}
                            />
                                {/* {validateCheck("otp") &&
                                    <small className={Styles.RQError}>
                                        <><img src={errorIcon} alt={"error"} className={Styles.errorIcon} />{t("verifyOTPVariableMandatory")}</>
                                    </small>} */}
                            </>
                        }
                    </>
                }
            </div >
        )
    }

    const sliderFooter = () => {
        return (
            <div className={Styles.modalButtonsWrapper}>
                <Button type="tertiary" onClick={() => onClose()}>{t("mainCancel")}</Button>
                <Button type="primary" disabled={checkSaveButtonEnabled()} onClick={handleSaveClick}>{t("mainSave")}</Button>
            </div>
        )
    }


    return (
        <Slider
            containerId="root-modal"
            onClose={onClose}
            visibility={true}
            footer={sliderFooter()}
            title={!isEmpty(editData) ? t('KLR00108') : t('temAddNewTemplate')}
        >{renderSliderBody()}</Slider>
    )
}

export default CreateFailoverTemplates;